import React from 'react';
import './MenuSearch.scss';
import { Icon } from 'antd';
import { FormattedMessage } from 'react-intl';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  onClose: () => void;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const MenuSearch: React.SFC<IProps> = ({
  onClose,
  onChange,
  onSubmit,
}) => (
  <WrapperLayout style='menu-search' align='middle'>
    <form onSubmit={ onSubmit }>
      <FormattedMessage 
        id='placeholder.searchevent'
        defaultMessage='Sök evenemang här!'>
          {
            (placeholderString: string) =>
            <input 
              type="text" 
              name='search-input'
              className='search-input'
              onChange={ onChange }
              placeholder={ placeholderString }
              autoComplete='off'
              required
            />
          }
      </FormattedMessage>
    </form>
    <Icon type='close' onClick={ onClose }/>
  </WrapperLayout>
);

export default MenuSearch;


// WEBPACK FOOTER //
// ./src/components/MenuSearch/MenuSearch.tsx